import intlTelInput from "intl-tel-input/intlTelInputWithUtils";
import { uk, en } from "intl-tel-input/i18n";

export function setupPhone() {
  document.querySelectorAll("input[name='your-phone' i]").forEach((element) => {
    const input = element as HTMLInputElement;
    intlTelInput(input, {
      i18n: document.documentElement.lang === "uk" ? uk : en,
      initialCountry: "ua",
      countryOrder: ["ua"],
      excludeCountries: ["by", "ru"],
    });
  });
}
